// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"BQd8QC"};